// Hands the one CampaignApi to every screen. Hooks get it with useApi(); nothing else creates an API.
import { createContext, useContext, type ReactNode } from 'react'
import type { CampaignApi } from './CampaignApi'

const ApiContext = createContext<CampaignApi | null>(null)

export function ApiProvider({ api, children }: { api: CampaignApi; children: ReactNode }) {
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>
}

export function useApi(): CampaignApi {
  const api = useContext(ApiContext)
  if (!api) throw new Error('ApiProvider is missing')
  return api
}
